import React from "react";
import clsx from "clsx";
import useSystemLogo from "@micado-digital/react-ui/hooks/useSystemLogo";
import ReactLink from "@micado-digital/react-link/ReactLink";
import useTheme from "@material-ui/core/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import styles from "./Logo.styles";

const Logo = ({ background = true }) => {
	const css = styles();
	const logo = useSystemLogo("logo");
	const { alt, homeLink, src } = logo;
	const theme = useTheme();
	const breakpointLG = useMediaQuery(theme.breakpoints.up("lg"));
	const logoHeight = breakpointLG ? 84 : 73;
	const logoWidth = breakpointLG ? 147 : 128;

	return (
		<div
			className={clsx(css.logo, "mco-view-component-logo", {
				[css.logoBackground]: background
			})}
		>
			<ReactLink to={homeLink}>
				<img alt={alt} height={logoHeight} src={src} width={logoWidth} />
			</ReactLink>
		</div>
	);
};

export default Logo;
